export default "<div class=\"blue\">\n    <div class=\"white\">\n        <app-club-list></app-club-list>\n    </div>\n</div>";